export default __webpack_public_path__ + "static/commercial-2922496e3f9459ac8e0b5bc5fe34886e.jpg";